import {
  BOOKS_USER_ENDPOINT,
  BOOKS_RETURN_DATES_ENDPOINT,
  BOOKS_PROGRESS_RESET_ENDPOINT,
  BOOKS_UPDATE_MANY_ENDPOINT,
  BOOKS_DISABLE_ENDPOINT,
  BOOKS_DISABLE_INVOICE_ENDPOINT,
  BOOKS_COMPLETE_ENDPOINT,
  BOOKS_SUMMARY_ENDPOINT,
  BOOKS_EMAIL_SUMMARY_ENDPOINT,
  SCHOOL_PURCHASE_FILE,
  BOOKS_MULTIPLE_STATUS_ENDPOINT,
} from "../Constants/Endpoints";
import { apiCallFile, apiCallJson } from "../Helpers";
import { objectToQueryString } from "../Helpers/utils/utils";

export async function getReturnDates() {
  return await apiCallJson(BOOKS_RETURN_DATES_ENDPOINT, "GET", null);
}

export async function getAllBooksByUserAsync() {
  return await apiCallJson(BOOKS_USER_ENDPOINT, "GET", null);
}

export async function resetUserProgress() {
  return await apiCallJson(BOOKS_PROGRESS_RESET_ENDPOINT, "POST", {});
}

export async function booksUpdateMany(body) {
  return await apiCallJson(BOOKS_UPDATE_MANY_ENDPOINT, "PUT", body);
}

export async function getBooksOfSchool(body) {
  return await apiCallJson(BOOKS_UPDATE_MANY_ENDPOINT, "PUT", body);
}

export async function putBookStatus(queryString) {
  return await apiCallJson(BOOKS_DISABLE_ENDPOINT + queryString, "PUT");
}

export async function putBookInvoice(queryString) {
  return await apiCallJson(BOOKS_DISABLE_INVOICE_ENDPOINT + queryString, "PUT");
}

export async function booksCompleteRequest(queryString) {
  return await apiCallJson(BOOKS_COMPLETE_ENDPOINT + queryString, "PUT", null);
}

export async function getSummaryRequest(queryString) {
  return await apiCallJson(BOOKS_SUMMARY_ENDPOINT + queryString, "GET", null);
}

export async function getEmailSummaryRequest(queryString) {
  return await apiCallJson(BOOKS_EMAIL_SUMMARY_ENDPOINT + queryString, "GET", null);
}

export async function putPurchaseFileRequest(file) {
  return await apiCallFile(SCHOOL_PURCHASE_FILE, "PUT", file);
}

export async function putMultipleStatusEndpoint(schoolId, books) {
  return await apiCallJson(
    BOOKS_MULTIPLE_STATUS_ENDPOINT +
      objectToQueryString({ schoolId: schoolId }, true),
    "PUT",
    books
  );
}
